import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import ReactDOM from 'react-dom';
import { attachProps } from './utils';
export var createOverlayComponent = function createOverlayComponent(displayName, controller) {
  var didDismissEventName = "on".concat(displayName, "DidDismiss");
  var didPresentEventName = "on".concat(displayName, "DidPresent");
  var willDismissEventName = "on".concat(displayName, "WillDismiss");
  var willPresentEventName = "on".concat(displayName, "WillPresent");

  var Overlay = /*#__PURE__*/function (_React$Component) {
    _inherits(Overlay, _React$Component);

    var _super = _createSuper(Overlay);

    function Overlay(props) {
      var _this;

      _classCallCheck(this, Overlay);

      _this = _super.call(this, props);
      _this.el = document.createElement('div');
      _this.handleDismiss = _this.handleDismiss.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Overlay, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpen) {
          this.present();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.overlay) {
          this.overlay.dismiss();
        }
      }
    }, {
      key: "handleDismiss",
      value: function handleDismiss(event) {
        if (this.props.onDidDismiss) {
          this.props.onDidDismiss(event);
        }

        if (this.props.forwardedRef) {
          this.props.forwardedRef.current = undefined;
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function () {
        var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(prevProps) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (this.overlay) {
                    attachProps(this.overlay, this.props, prevProps);
                  }

                  if (prevProps.isOpen !== this.props.isOpen && this.props.isOpen === true) {
                    this.present(prevProps);
                  }

                  if (!(this.overlay && prevProps.isOpen !== this.props.isOpen && this.props.isOpen === false)) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 5;
                  return this.overlay.dismiss();

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function componentDidUpdate(_x) {
          return _componentDidUpdate.apply(this, arguments);
        }

        return componentDidUpdate;
      }()
    }, {
      key: "present",
      value: function () {
        var _present = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(prevProps) {
          var _this2 = this,
              _Object$assign;

          var _a, children, isOpen, onDidDismiss, onDidPresent, onWillDismiss, onWillPresent, cProps, elementProps;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _a = this.props, children = _a.children, isOpen = _a.isOpen, onDidDismiss = _a.onDidDismiss, onDidPresent = _a.onDidPresent, onWillDismiss = _a.onWillDismiss, onWillPresent = _a.onWillPresent, cProps = __rest(_a, ["children", "isOpen", "onDidDismiss", "onDidPresent", "onWillDismiss", "onWillPresent"]);
                  elementProps = Object.assign(Object.assign({}, cProps), (_Object$assign = {
                    ref: this.props.forwardedRef
                  }, _defineProperty(_Object$assign, didDismissEventName, this.handleDismiss), _defineProperty(_Object$assign, didPresentEventName, function (e) {
                    return _this2.props.onDidPresent && _this2.props.onDidPresent(e);
                  }), _defineProperty(_Object$assign, willDismissEventName, function (e) {
                    return _this2.props.onWillDismiss && _this2.props.onWillDismiss(e);
                  }), _defineProperty(_Object$assign, willPresentEventName, function (e) {
                    return _this2.props.onWillPresent && _this2.props.onWillPresent(e);
                  }), _Object$assign));
                  _context2.next = 4;
                  return controller.create(Object.assign(Object.assign({}, elementProps), {
                    component: this.el,
                    componentProps: {}
                  }));

                case 4:
                  this.overlay = _context2.sent;

                  if (this.props.forwardedRef) {
                    this.props.forwardedRef.current = this.overlay;
                  }

                  attachProps(this.overlay, elementProps, prevProps);
                  _context2.next = 9;
                  return this.overlay.present();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function present(_x2) {
          return _present.apply(this, arguments);
        }

        return present;
      }()
    }, {
      key: "render",
      value: function render() {
        return ReactDOM.createPortal(this.props.isOpen ? this.props.children : null, this.el);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }]);

    return Overlay;
  }(React.Component);

  return React.forwardRef(function (props, ref) {
    return React.createElement(Overlay, Object.assign({}, props, {
      forwardedRef: ref
    }));
  });
};